export enum GridConnectionReadiness {
  IT_EXISTS_NO_UPDATES_REQUIRED = 'IT_EXISTS_NO_UPDATES_REQUIRED',
  TO_BE_UPGRADED = 'TO_BE_UPGRADED',
  TO_BE_BUILT_BY_GRID_OPERATOR = 'TO_BE_BUILT_BY_GRID_OPERATOR',
  TO_BE_BUILD_BY_RWE = 'TO_BE_BUILD_BY_RWE',
  NOT_APPLICABLE = 'NOT_APPLICABLE',
}
export const gridConnectionReadinessToLabel = {
  [GridConnectionReadiness.IT_EXISTS_NO_UPDATES_REQUIRED]: 'It exists, no upgrades are required',
  [GridConnectionReadiness.TO_BE_UPGRADED]: 'To be upgraded',
  [GridConnectionReadiness.TO_BE_BUILT_BY_GRID_OPERATOR]: 'To be built by Grid Operator',
  [GridConnectionReadiness.TO_BE_BUILD_BY_RWE]: 'To be built by RWE',
  [GridConnectionReadiness.NOT_APPLICABLE]: 'Not Applicable',
};
